import React, { useState } from "react";
import { Tag } from "antd";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
import { deleteHolidays } from "../../connections/deleteHolidays";
import { toast } from "react-toastify";
import { imagesend } from "../imagepath";
import { getAiSummaryDetails } from "../../connections/getAiSummaryDetails";
import { deleteAiSummary } from "../../connections/deleteAiSummary";

const formatKey = (key) =>
  key
    .replace(/^_/, "")
    .replace(/_/g, " ")
    .replace(/([A-Z])/g, " $1")
    .trim()
    .replace(/^\w/, (c) => c.toUpperCase());

const renderValue = (value) => {
  if (value === null || value === undefined || value === "")
    return <span className="text">—</span>;

  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean")
    return <span className="text">{String(value)}</span>;

  if (Array.isArray(value)) {
    if (value.length === 0) return <span className="text">—</span>;

    if (typeof value[0] === "object" && value[0] !== null) {
      const isTranscript = "q" in value[0] && "a" in value[0];

      if (isTranscript) {
        return (
          <div style={{ marginTop: 8 }}>
            {value.map((item, i) => {
              const parts = String(item.a ?? "")
                .split(/;\s*/)
                .filter(Boolean);
              const isMultiPart = parts.length > 1 && parts[0].includes(":");

              return (
                <div
                  key={i}
                  style={{
                    border: "1px solid #e8e8e8",
                    borderRadius: 8,
                    marginBottom: 10,
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      background: "#f0f4ff",
                      padding: "8px 14px",
                      display: "flex",
                      gap: 10,
                      alignItems: "flex-start",
                    }}
                  >
                    <span
                      style={{
                        background: "#2463eb",
                        color: "#fff",
                        borderRadius: "50%",
                        minWidth: 22,
                        height: 22,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 11,
                        fontWeight: 700,
                        marginTop: 1,
                      }}
                    >
                      {i + 1}
                    </span>
                    <span style={{ fontSize: 13, fontWeight: 600, color: "#1a1a2e", lineHeight: 1.5 }}>
                      {item.q}
                    </span>
                  </div>
                  <div style={{ background: "#fff", padding: "8px 14px 10px 46px" }}>
                    {isMultiPart ? (
                      <ul style={{ margin: 0, paddingLeft: 16 }}>
                        {parts.map((part, j) => {
                          const colonIdx = part.indexOf(":");
                          if (colonIdx === -1)
                            return (
                              <li key={j} style={{ fontSize: 13, color: "#444", marginBottom: 2 }}>
                                {part}
                              </li>
                            );
                          const label = part.slice(0, colonIdx).trim();
                          const val = part.slice(colonIdx + 1).trim();
                          return (
                            <li key={j} style={{ fontSize: 13, color: "#444", marginBottom: 2 }}>
                              <span style={{ fontWeight: 600, color: "#555" }}>{label}:</span>{" "}
                              {val || <span style={{ color: "#aaa" }}>—</span>}
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <span style={{ fontSize: 13, color: "#444" }}>{item.a || "—"}</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        );
      }

      const isMedicine = "medicine_name" in value[0];

      if (isMedicine) {
        return (
          <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 10 }}>
            {value.map((item, i) => (
              <div
                key={i}
                style={{
                  border: "1px solid #e8e8e8",
                  borderRadius: 8,
                  overflow: "hidden",
                  flex: "1 1 220px",
                  maxWidth: 300,
                }}
              >
                <div
                  style={{
                    background: "#f0f4ff",
                    padding: "8px 14px",
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <span
                    style={{
                      background: "#2463eb",
                      color: "#fff",
                      borderRadius: "50%",
                      minWidth: 22,
                      height: 22,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 11,
                      fontWeight: 700,
                    }}
                  >
                    {i + 1}
                  </span>
                  <span style={{ fontSize: 14, fontWeight: 700, color: "#1a1a2e" }}>
                    {item.medicine_name ?? "—"}
                  </span>
                </div>
                {item.remarks && (
                  <div style={{ background: "#fff", padding: "8px 14px 10px 46px" }}>
                    <span style={{ fontSize: 12, color: "#888", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                      Remarks
                    </span>
                    <p style={{ margin: "2px 0 0", fontSize: 13, color: "#444", lineHeight: 1.5 }}>
                      {item.remarks}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        );
      }

      return (
        <div style={{ marginTop: 8 }}>
          {value.map((item, i) => (
            <div
              key={i}
              style={{
                background: "#f9f9f9",
                border: "1px solid #eee",
                borderRadius: 6,
                padding: "10px 14px",
                marginBottom: 8,
              }}
            >
              {Object.entries(item).map(([k, v]) => (
                <div key={k} style={{ marginBottom: 6, display: "flex", flexDirection: "column" }}>
                  <span style={{ fontSize: 11, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    {formatKey(k)}
                  </span>
                  <span style={{ fontSize: 13, color: "#444", marginTop: 2 }}>{String(v ?? "—")}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      );
    }

    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 4 }}>
        {value.map((item, i) => (
          <Tag key={i} color="default" style={{ margin: 0 }}>
            {String(item)}
          </Tag>
        ))}
      </div>
    );
  }

  if (typeof value === "object") {
    return (
      <ul
        className="personal-info"
        style={{ paddingLeft: 16, marginTop: 4, marginBottom: 0 }}
      >
        {Object.entries(value).map(([k, v]) => (
          <li
            key={k}
            className="pb-1"
            style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", borderBottom: "none" }}
          >
            <span className="title" style={{ whiteSpace: "nowrap" }}>{formatKey(k)}:</span>
            <div style={{ marginTop: 2 }}>{renderValue(v)}</div>
          </li>
        ))}
      </ul>
    );
  }

  return <span className="text">{String(value)}</span>;
};

const ShowAiSummary = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState("");

  const { data, isLoading } = useQuery({
    queryKey: ["getAiSummaryDetails", id],
    queryFn: () => getAiSummaryDetails(user?.token, id),
    enabled: !!id,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const deleteHolidaysFun = async () => {
    try {
      const res = await deleteAiSummary(user?.token, deleteId);
      if (res.status.status === "SUCCESS") {
        toast.success("Ai Summary Deleted Successfully");
        navigate("/admin/ai_summary");
        setDeleteId(null);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const summaryJson = data?.summary_json;

  return (
    <>
      <Header />
      <Sidebar activeClassName="ai_summary" />
      <>
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Ai Summary List</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Ai Summary Details</h3>
                            <button
                              className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                              style={{
                                minWidth: "100px",
                                padding: "6px 12px",
                                borderRadius: "6px",
                              }}
                              data-bs-toggle="modal"
                              data-bs-target="#delete_patient"
                              onClick={() => setDeleteId(data?.id)}
                            >
                              <i className="fa fa-trash-alt me-2" />
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {isLoading ? (
                      <Skeleton variant="rectangular" width="100%" height={430} />
                    ) : (
                      <div className="content-details">
                        {/* ── Static info ── */}
                        <div className="col-lg-12 mb-3">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                {[
                                  {
                                    label: "Patient",
                                    value: (
                                      <>
                                        <Link
                                          to={`/admin/patient/${data?.patient_id}`}
                                          style={{ textDecoration: "underline" }}
                                        >
                                          {data?.patient_name || data?.patient_id}
                                        </Link>
                                        {data?.patient_uid && (
                                          <span style={{ color: "#888", marginLeft: 6 }}>
                                            ({data.patient_uid})
                                          </span>
                                        )}
                                      </>
                                    ),
                                  },
                                  { label: "Resource Id", value: data?.resource_id ?? "—" },
                                  { label: "Resource Type", value: data?.resource_type ?? "—" },
                                  { label: "Summary Type", value: data?.summary_type ?? "NA" },
                                  ...(() => {
                                    const fileName =
                                      data?.file_url?.filename || data?.file_name;
                                    const fileHref =
                                      data?.file_url?.url || data?.file_uri;
                                    if (!fileName && !fileHref) return [];
                                    return [
                                      {
                                        label: "File",
                                        value: fileHref ? (
                                          <a
                                            href={fileHref}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ textDecoration: "underline" }}
                                          >
                                            {fileName || fileHref}
                                          </a>
                                        ) : (
                                          fileName
                                        ),
                                      },
                                    ];
                                  })(),
                                  { label: "Created At", value: data?.created_at ?? "—" },
                                  { label: "Updated At", value: data?.updated_at ?? "—" },
                                ].map(({ label, value }) => (
                                  <li
                                    key={label}
                                    className="pb-1"
                                    style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
                                  >
                                    <span className="title" style={{ whiteSpace: "nowrap" }}>{label}:</span>
                                    <span className="text" style={{ marginTop: 2 }}>{value}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>

                        {/* ── Transcription ── */}
                        {data?.transcription && (
                          <div className="col-lg-12 mb-3">
                            <div className="card-box">
                              <div className="card-block">
                                <h5 className="card-title" style={{ marginBottom: 12 }}>
                                  Transcription
                                </h5>
                                <pre
                                  style={{
                                    maxHeight: 300,
                                    overflowY: "auto",
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    background: "#f6f6f6",
                                    border: "1px solid #e8e8e8",
                                    borderRadius: 6,
                                    padding: "10px 14px",
                                    fontSize: 12,
                                    lineHeight: 1.6,
                                    margin: 0,
                                    color: "#444",
                                  }}
                                >
                                  {(() => {
                                    try {
                                      return JSON.stringify(JSON.parse(data.transcription), null, 2);
                                    } catch {
                                      return data.transcription;
                                    }
                                  })()}
                                </pre>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* ── Dynamic summary_json ── */}
                        {summaryJson && Object.keys(summaryJson).length > 0 && (
                          <div className="col-lg-12">
                            <div className="card-box">
                              <div className="card-block">
                                <h5 className="card-title" style={{ marginBottom: 16 }}>
                                  Summary
                                </h5>
                                <ul className="personal-info">
                                  {Object.entries(summaryJson).map(([key, value]) => (
                                    <li
                                      key={key}
                                      className="pb-1"
                                      style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
                                    >
                                      <span className="title" style={{ whiteSpace: "nowrap" }}>{formatKey(key)}:</span>
                                      <div style={{ marginTop: 2 }}>{renderValue(value)}</div>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="delete_patient" className="modal fade delete-modal" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  <Link to="#" className="btn btn-white me-2" data-bs-dismiss="modal">
                    Close
                  </Link>
                  <button
                    onClick={deleteHolidaysFun}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default ShowAiSummary;
